import { ILocationWarningState, WarningLoadingState } from 'redux-state/weather-warnings/types.js';
import { WarningsPanelHeaderFailure } from './header-failure.js';
import { WarningsPanelHeaderLoadedEmpty } from './header-loaded-empty.js';
import { WarningsPanelHeaderLoaded } from './header-loaded.js';
import { WarningsPanelHeaderLoading } from './header-loading.js';
import { IWarningsPanelData } from './warning-panel-data.js';

export const WarningsPanelHeader = ({
  warningState,
  warningMeta,
}: {
  warningMeta?: ILocationWarningState;
  warningState?: IWarningsPanelData;
}) => {
  if (warningState?.type === WarningLoadingState.loading) {
    return <WarningsPanelHeaderLoading area={warningMeta?.warningAreaName} />;
  }
  if (warningState?.type === WarningLoadingState.loaded) {
    const loadedContent =
      'list' in warningState ? (
        <WarningsPanelHeaderLoaded warnings={warningState.list} />
      ) : (
        <WarningsPanelHeaderLoadedEmpty warningMeta={warningMeta} />
      );
    return <>{loadedContent}</>;
  }
  return <WarningsPanelHeaderFailure />;
};
